import React, { useEffect, useState } from "react";
import useFooter from "../../hooks/useFooter";
import QuestionFooter from "../Footer/QuestionFooter";
import { incrementPeekSlide } from "../../store/slices/slides";
import { useDispatch } from "react-redux";
import { updateQuestion } from "../../store/slices/assessment";

function DifficultySlide({ title = "Difficulty", isVisible }) {
  const dispatch = useDispatch();
  useFooter(isVisible, <QuestionFooter />);

  const [rangeValue, setRangeValue] = useState(0);
  const [peekValueUpdated, setPeekValueUpdated] = useState(false);

  useEffect(() => {
    // colorize step options
    const ctrl = document.querySelector(".__range-step");
    const el = ctrl?.querySelector("input");
    if (!el) {
      return;
    }
    ctrl?.querySelectorAll("option").forEach((opt) => {
      if (parseInt(opt?.value) <= el?.valueAsNumber) {
        opt.style.backgroundColor = "#293A8D";
      } else {
        opt.style.backgroundColor = "#EAEBED";
      }
    });

    // colorize before and after
    const valPercent =
      (el.valueAsNumber - parseInt(el.min)) /
      (parseInt(el.max) - parseInt(el.min));
    const styleObj = {
      backgroundImage: `-webkit-gradient(linear, 0% 0%, 100% 0%, color-stop(${valPercent}, #293A8D), color-stop(${valPercent}, #EAEBED))`,
    };
    Object.assign(el.style, styleObj);
  }, [rangeValue]);

  const handleRangeChange = (event) => {
    setRangeValue(parseInt(event.target.value));
    handleChange(event);
  };

  const handleChange = (event) => {
    const value = event?.target?.value;

    if (!value && value !== 0) {
      console.log("Value is null or undefined", value, event);
      return;
    }

    if (!peekValueUpdated) dispatch(incrementPeekSlide());
    setPeekValueUpdated(true);

    dispatch(updateQuestion({ title, value }));
  };

  return (
    <div className="h-full bg-difficulty-content">
      <div className="block-emotti ">
        <div className="block-tip" id="close_tip">
          <h1 className="">
            Managing Life
            <span className="mt-10">
              In the last two weeks overall, how much difficulty have you been
              having managing one or more of the following areas: work, home,
              relationships, management of your health?
            </span>
          </h1>

          <div className="info-box">
            <ul className="value-list">
              <li>0 = not at all difficult</li>
              <li>2 = somewhat difficult</li>
              <li>4 = very difficult </li>
              <li>6 = extremely difficult</li>
            </ul>
          </div>

          <div className="">
            <div className="range-slider">
              <fieldset className="formSlider">
                <div className="__range __range-step" id="input_list">
                  <span
                    className={`hide-value ${peekValueUpdated ? "hide" : ""}`}
                    onClick={() => handleRangeChange({ target: { value: 0 } })}
                    // style={{ pointerEvents: "none" }}
                  ></span>
                  <input
                    value={rangeValue}
                    type="range"
                    max={6}
                    min={0}
                    step={1}
                    list="ticks1"
                    onChange={handleRangeChange}
                  />
                  <datalist id="ticks1" className="text-white">
                    <option value="0">
                      <span>0</span>
                    </option>
                    <option value="1">
                      <span>1</span>
                    </option>
                    <option value="2">
                      <span>2</span>
                    </option>
                    <option value="3">
                      <span>3</span>
                    </option>
                    <option value="4">
                      <span>4</span>
                    </option>
                    <option value="5">
                      <span>5</span>
                    </option>
                    <option value="6">
                      <span>6</span>
                    </option>
                  </datalist>
                  <ul className="value-text text-white">
                    <li>0</li>
                    <li>1</li>
                    <li>2</li>
                    <li>3</li>
                    <li>4</li>
                    <li>5</li>
                    <li>6</li>
                  </ul>
                </div>
              </fieldset>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DifficultySlide;
